import moment from 'moment';

function dateTransformer(value) {
    let date = moment(value.replace(/\s/, 'T'));
    let res = '';
    if (date) {
        res = date.format('DD.MM.YYYY');
    }
    return res;
}

function spaceModuleMediumTransformer(value) {
    let res = '';
        switch (value.toLowerCase()) {
            case 'online':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;cursor: pointer" class="margin-right hover-highlight icon-device-xdigital"></span>';
                break;
                case 'desktop':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;cursor: pointer" class="margin-right hover-highlight icon-device-desktop"></span>';
                break;
            case 'mobile':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;cursor:pointer;" class="margin-right hover-highlight icon-device-mobile"></span>';
                break;
            case 'tablet':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;cursor:pointer;" class="margin-right hover-highlight icon-device-tablet"></span>';
                break;
        }
    return res;
}

function interactionMediumTransformer(value) {
    let res = '';
    for (let i = 0; i < value.length; i++) {
        let medium = value[i];
        switch (medium) {
            case 'online':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;cursor: pointer" class="margin-right hover-highlight icon-device-xdigital"></span>';
                break;
                case 'desktop':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;cursor: pointer" class="margin-right hover-highlight icon-device-desktop"></span>';
                break;
            case 'mobile':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;cursor:pointer" class="margin-right hover-highlight icon-device-mobile"></span>';
                break;
            case 'tablet':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;cursor:pointer" class="margin-right hover-highlight icon-device-tablet"></span>';
                break;
        }
    }
    return res;
}

function actionTransformer(value) {
    let res = '';
    value.forEach(action => {
        switch (action) {
            case 'edit':
                res += '<span data-type="edit" style="cursor: pointer" class="margin-right hover-highlight icon-edit"></span>';
                break;
            case 'copy':
                res += '<span data-type="duplicate" style="cursor: pointer" class="margin-right hover-highlight icon-duplicate"></span>';
                break;
            case 'delete':
                res += '<span data-type="delete" style="cursor: pointer" class="margin-right hover-highlight icon-delete"></span>';
                break;
        }
    });
    return res;
}

export default {
    dateTransformer,
    spaceModuleMediumTransformer,
    actionTransformer,
    interactionMediumTransformer
}